import { Component, ElementRef, OnInit, SecurityContext } from '@angular/core';
import { InceptionService, TranslationService } from '@proximus/ng-common';
import { HttpClient } from '@angular/common/http';
import { DomSanitizer } from '@angular/platform-browser';
import { ActivatedRoute } from '@angular/router';
import { OnDestroyHookDirective } from 'src/app/shared/hooks/hook-ondestroy';


@Component({
  selector: 'mprd-norton-details',
  templateUrl: './norton-details.component.html',
  styleUrls: ['./norton-details.component.css'],
})
export class NortonDetailsComponent extends OnDestroyHookDirective implements OnInit {
  backUrlFromApp: string;
  faqHtml?: string;
  isNortonFamily = false;
  constructor(
    private inceptionService: InceptionService,
    private translationService: TranslationService,
    private elementRef: ElementRef,
    private http: HttpClient,
    private readonly sanitizer: DomSanitizer,
    private readonly activatedRoute: ActivatedRoute,
  ) {
    super();
  }

  ngOnInit() {
    if (window['MyProximusMobileApp']) {
      this.backUrlFromApp = this.translationService.getTranslatedValueFor(
        'common.myproximus.back.url',
      );
    }
    this.scrollToTop();

    const url = 'norton-details-faq%7EmgnlArea=body%7E.html';
    this.http.get(url, { responseType: 'text' }).subscribe((response) => {
      this.faqHtml = this.sanitizer.sanitize(SecurityContext.HTML, response);
    });
    const nortonFamilyMpcUuid = this.translationService.getTranslatedValueFor(
      'norton.subscription.nortonFamilyMpcUuid',
    );
    this.addSubscription(
    this.activatedRoute?.params?.subscribe((params) => {
      const { mpcUuid } = params || {};
      this.isNortonFamily = mpcUuid === nortonFamilyMpcUuid;
    })
  );
  }
  private scrollToTop(): void {
    setTimeout(() => {
      this.inceptionService.scrollToElement('#nortonDetails');
    });
  }

  goBack() {
    this.backUrlFromApp
      ? window.open(this.backUrlFromApp)
      : window.history.back();
  }
}
